import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { NavLink, useNavigate } from 'react-router-dom';

import { Config } from '../../common/config';
import AlertModal from '../../components/alertModal';
import LeftMenu from '../../components/leftMenu';
import { getErrorMessage } from '../../components/utils';
import useStoreNo from '../../hooks/useStoreNo';

export default function UserWithdrawal() {
  const navigate = useNavigate();
  const userInfo = useSelector(state => state.userInfo);
  const storeNo = useStoreNo();

  const [modalOpen, setModalOpen] = useState(false); //모달 상태 관리 : 기본값 - 닫힘
  const [modalInfo, setModalInfo] = useState({
    isCancel: true,
    isConfirm: true,
    isMessage: true,
    headerMsg: '',
    actionFlag: '',
    mainMsg: '',
    action: '',
    isPercent: false,
  });
  const openModal = () => {
    if (modalInfo.actionFlag === 'del') {
      setModalInfo({
        ...modalInfo,
        actionFlag: 'del',
        mainMsg: '정말 탈퇴하시겠습니까?\n탈퇴 후 정보 복구가\n불가능합니다.',
      });
    }
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);

    navigate(`/${storeNo}/user-manage`);
  };

  const doModal = () => {
    setModalOpen(false);
    if (modalInfo.actionFlag === 'del') {
      delUser();
    } else if (modalInfo.actionFlag === 'goMain') {
      navigate('/go-main');
    }
  };

  // JWT refresh handled centrally in request layer

  const delUser = async () => {
    try {
      await axios.delete(`${Config.API_SERVER}detail/${userInfo.id}`, {
        withCredentials: true,
      });

      // URL 생성
      const url = `${Config.SHOPMAIN_SERVER}`;

      // URL 이동
      window.location.href = url;

      // navigate('/');
    } catch (error) {
      setModalInfo({
        ...modalInfo,
        actionFlag: 'api',
        mainMsg: getErrorMessage(error?.response),
      });
      setModalOpen(true);
      console.error('Error fetching data:', error);
    }
  };

  useEffect(() => {}, []);

  return (
    <>
      <AlertModal
        open={modalOpen}
        close={closeModal}
        action={doModal}
        header={modalInfo.headerMsg}
        isConfirm={modalInfo.isConfirm}
        isMessage={modalInfo.isMessage}
        isCancel={modalInfo.isCancel}
      >
        {modalInfo.mainMsg}
      </AlertModal>

      <section className="location_box location_box_mypage">
        <ul className="location_001">
          <li>
            <NavLink to={storeNo ? `/${storeNo}/gift-list` : '/gift-list'}>
              홈
            </NavLink>
          </li>
          <li>
            <NavLink to={storeNo ? `/${storeNo}/user-manage` : '/user-manage'}>
              관리자 정보 관리
            </NavLink>
          </li>
          <li>회원탈퇴</li>
        </ul>
      </section>

      <main>
        <section className="contants_box contants_box_mypage">
          <LeftMenu pageName="user" />

          <section className="rightcontant_box">
            <h2 className="tit_01">회원탈퇴</h2>

            <main>
              <section className="contants_box_04">
                <article className="signup_07">
                  <h2 className="tit_01">
                    회원탈퇴란,
                    <br />
                    내기프트에 대한 이용해지를 의미합니다.
                  </h2>
                  <br />
                </article>

                <article class="contants_box_03">
                  <div class="signup_07_001">
                    &ensp;&ensp;
                    <span style={{ color: 'blue', fontSize: '18px' }}>
                      - 회원탈퇴 시 유의사항
                    </span>
                    <br />
                    &ensp;&ensp;회원탈퇴를 위해서는 아래 조건에 대한 확인이
                    필요합니다.
                    <br />
                    <br />
                    <p class="signup_07_002 font_red">
                      1. 등록하신 상점 기프트 QR코드는 사용이 불가능해집니다.
                    </p>
                    <p class="signup_07_002 font_red">
                      2.고객들이 보유한 기프트는 더 이상 사용이 불가능해집니다.
                    </p>
                    <p class="signup_07_002 font_red">
                      3.예치 금액은 기프트 구매자에게 환불됩니다.
                    </p>
                    <p class="signup_07_002 font_red">
                      4. 동일한 아이디로 재가입은 불가능하며 새로운 아이디로만
                      재가입이 가능합니다.
                    </p>
                  </div>
                </article>

                <div>
                  <br /> <br />
                </div>
                <article class="button_box_01">
                </article>
              </section>
            </main>
          </section>
        </section>
      </main>
    </>
  );
}
